module.exports = __webpack_public_path__ + "operace-usnich-boltcu_1_before_tn.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures_tn/plasticka-chirurgie/operace-usnich-boltcu_1_before_tn.jpg
// module id = 1680
// module chunks = 0